import ClientAgent from '../../clientAgent'

export default class ProjectDetailsPermission {
  _ca = null
  /** @type {string|null} */
  _permission = null
  /** @type {string|null} */
  _permissionGiver = null
  /** @type {string|null} */
  _permissionGiverEmail = null
  /** @type {string|null} */
  _permissionGiverName = null
  /** @type {string|null} */
  _permissionName = null
  /** @type {string|null} */
  _permissionReceiver = null
  /** @type {string|null} */
  _permissionReceiverEmail = null
  /** @type {string|null} */
  _permissionReceiverName = null
  /** @type {number|null} */
  _requestId = null
  /** @type {number|null} */
  _grantedId = null
  /** @type {string|null} */
  _date = null
  /** @type {int|null} */
  _resourceId = null
  /** @type {string|null} */
  _resourceName = null

  constructor (item) {
    for (const prop in item) {
      if (this[prop] !== undefined || this['_' + prop] !== undefined) {
        this[prop] = item[prop]
      }
    }
  }

  async acceptPermissionRequest () {
    await this.ca.makeRequest('permissions/respondPermissionGrant', {id: this._requestId, accept: true})
  }

  async declinePermissionRequest () {
    await this.ca.makeRequest('permissions/respondPermissionGrant', {id: this._requestId, accept: false})
  }

  async cancelPermissionRequest () {
    await this.ca.makeRequest('openStack/servisne/witdhrawPermissionGrantRequest', {id: this._requestId})
  }

  async removePermission () {
    await this.ca.makeRequest('openStack/servisne/withdrawPermission', {id: this._grantedId})
  }

  /**
   * @returns {ClientAgent}
   */
  get ca () {
    if (this._ca === null) {
      this._ca = new ClientAgent()
    }
    return this._ca
  }

  set ca (value) {
    this._ca = value
  }

  get permission () {
    return this._permission
  }

  set permission (value) {
    this._permission = value
  }

  get permissionGiver () {
    return this._permissionGiver
  }

  set permissionGiver (value) {
    this._permissionGiver = value
  }

  get permissionGiverEmail () {
    return this._permissionGiverEmail
  }

  set permissionGiverEmail (value) {
    this._permissionGiverEmail = value
  }

  get permissionGiverName () {
    return this._permissionGiverName
  }

  set permissionGiverName (value) {
    this._permissionGiverName = value
  }

  get permissionName () {
    return this._permissionName
  }

  set permissionName (value) {
    this._permissionName = value
  }

  get permissionReceiver () {
    return this._permissionReceiver
  }

  set permissionReceiver (value) {
    this._permissionReceiver = value
  }

  get permissionReceiverEmail () {
    return this._permissionReceiverEmail
  }

  set permissionReceiverEmail (value) {
    this._permissionReceiverEmail = value
  }

  get permissionReceiverName () {
    return this._permissionReceiverName
  }

  set permissionReceiverName (value) {
    this._permissionReceiverName = value
  }

  get requestId () {
    return this._requestId
  }

  set requestId (value) {
    this._requestId = value
  }

  get grantedId () {
    return this._grantedId
  }

  set grantedId (value) {
    this._grantedId = value
  }

  get date () {
    return this._date
  }

  set date (value) {
    this._date = value
  }

  get resourceId () {
    return this._resourceId
  }

  set resourceId (value) {
    this._resourceId = value
  }

  get resourceName () {
    return this._resourceName
  }

  set resourceName (value) {
    this._resourceName = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/T2Cloud/Response/ProjectDetailsPermission.js